import { ActivatedRouteSnapshot } from '@angular/router';
import { injectDispatch } from '@ngrx/signals/events';

import { Submission } from '../../../submissions/next/models';
import { TASK_EVENTS } from '@data-access/tasks/store';
import { taskTokenizer } from '@data-access/tasks/store/token';

/**
 * NOTE: This resolver is used to load the task list for the documents section of a submission.
 * We do not explicitly call task list in the draft stage unless the user navigates to the documents section.
 * This is to avoid loading tasks unnecessarily for other sections of the submission.
 */
export const documentsSectionResolver = (route: ActivatedRouteSnapshot) => {
  const _taskStore = taskTokenizer();
  const _taskEventDispatcher = injectDispatch(TASK_EVENTS);
  const submission = route.parent?.data['submission'] as Submission;

  if (submission?.id) {
    _taskEventDispatcher.getTaskList({
      submissionStage: submission?.current_stage || '',
      workspaceID: submission.id,
    });
  }

  return true;
};
